import { monthOptions } from "constants/month"

export const monthConvert = (month) => {
  if (typeof month === 'undefined') return

  return monthOptions.find((v) => parseFloat(v.value) === parseFloat(month))?.label
}